import React from 'react';
import { Select } from 'antd';
import { DEPLOY_ENV } from "../utils/config";
import './MwsEnvironmentSelector.css';

const { Option } = Select;

export const MWS_ENVIRONMENT_OPTIONS = [
    { label: 'dev', value: 'dev' },
    { label: 'test', value: 'test' },
    { label: 'staging', value: 'staging' },
    { label: 'prod', value: 'prod' },
];

interface EnvironmentSelectorProps {
    prefix: string;
    enableDevHost?: boolean;
    enableStagingHost?: boolean;
}

const MwsEnvironmentSelector: React.FC<EnvironmentSelectorProps> = ({ prefix, enableDevHost = false, enableStagingHost = true }) => {
    const onChange = (value: string) => {
        let host: string;
        if (value === 'dev'){
            host = 'mws-dev.haiskynology.com';
        }
        else if (value === 'test') {
            host = 'mws-test.haiskynology.com';
        } else if (value === 'staging') {
            host = 'mws-st.haiskynology.com';
        } else {
            host = 'mws.haiskynology.com';
        }
        if (host === window.location.host) {
            return;
        }
        window.open(`https://${prefix}.${host}${window.location.pathname}`, '_blank');
    }
    return (
        <Select value={DEPLOY_ENV} className="environment-selector" onChange={onChange}>
            {MWS_ENVIRONMENT_OPTIONS
                .filter(option => enableDevHost || option.value !== 'dev')
                .filter(option => enableStagingHost || option.value !== 'staging')
                .map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
        </Select>
    );
};

export default MwsEnvironmentSelector;
